import React from "react"
import Block from "@bappweb/block"
import Panel from "@bappweb/panel"
import Page from "@smpu-web/globalmodules/page"
import "../assets/style.scss"
import { useAppSelector } from "../../../config/hook"
import { getConfigValue } from "@smpu-web/utils/utils"

const Notes = () => {
    const sessionData = useAppSelector((state) => state.sessionData.response)

    return (
        <Page padding={false}>
            <Panel hasFooter={false} noHeader className="notes-container">
                <Block dangerouslySetInnerHTML={{ __html: getConfigValue(sessionData?.configList, "UniversiteliAkbankli.Landing.Bottom") }} />
            </Panel>
        </Page>
    )
}

export default Notes
